import { msalEnvironment } from "../../../authentication/authConfig";
import { axiosGQL } from "../../../App";

//#region Fetch Assets
export function AssetsGQL() {
    return axiosGQL({
        url: msalEnvironment.axiosURL,
        method: "post",
        data: {
            query: `
            query Images{
                appImages_PricingTool
                }`,
        }
    })
};
//#endregion